import { render } from "./DriverArchive.vue?vue&type=template&id=a2a651ca"
import script from "./DriverArchive.vue?vue&type=script&lang=js"
export * from "./DriverArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__